import React, { useEffect } from 'react';
import { Typography, Box, Theme, Button } from '@mui/material';
import { createStyles, withStyles, WithStyles } from '@mui/styles';
import { observer, inject } from 'mobx-react';

import StoreModel from 'models/Index';
import { Services, history, RoutePaths } from 'helpers';
import Header from 'components/admin/Header';

interface CollectionSuccessProps extends WithStyles<typeof styles> {}
interface CollectionSuccessInject extends CollectionSuccessProps {
    Store: StoreModel;
}

const styles = (theme: Theme) =>
    createStyles({
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            height: '170px',
        },
        headerLine: {
            height: '6px',
            background: '#e0e0e0',
        },
        main: {
            margin: '0px 60px',
        },
        title: {
            marginTop: '66px',
        },
        subTitle: {
            marginTop: '36px',
        },
        buttonBox: {
            display: 'flex',
            left: 60,
            right: 60,
            position: 'fixed',
            bottom: '105px',
            justifyContent: 'space-between',
        },
        button: {
            height: '88px',
            minWidth: '360px',
        },
    });

const CollectionSuccess = ({ classes, Store }: CollectionSuccessInject) => {
    const { printCashCollectionReport, userCashMetrics, cleanData } =
        Store.collection;

    useEffect(() => {
        if (!userCashMetrics) {
            history.push({
                pathname: RoutePaths.CashCollection,
                search: window.location.search,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Box className={classes.header}>
                <Header />
            </Box>
            <div className={classes.headerLine}></div>

            <Box className={classes.main}>
                <Typography
                    color='primary'
                    variant='h2'
                    align='center'
                    className={classes.title}
                >
                    Cash Collection
                </Typography>

                <Typography
                    variant='h4'
                    align='center'
                    className={classes.subTitle}
                >
                    Successfully submitted cash collection!
                </Typography>
                <Typography variant='h4' align='center'>
                    Would you like to print a receipt?
                </Typography>

                <Box className={classes.buttonBox}>
                    <Button
                        className={classes.button}
                        variant='secondary'
                        onClick={() => {
                            history.push({
                                pathname: RoutePaths.IdleScreen,
                                search: window.location.search,
                            });
                            cleanData();
                        }}
                    >
                        <Typography variant='button'>Exit</Typography>
                    </Button>
                    <Button
                        className={classes.button}
                        variant='primary'
                        onClick={() => {
                            printCashCollectionReport();
                        }}
                    >
                        <Typography variant='button'>Print</Typography>
                    </Button>
                </Box>
            </Box>
        </>
    );
};

export default withStyles(styles)(
    inject(Services.STORE)(observer(CollectionSuccess))
);
